import * as yup from 'yup';

import type { TFunction } from 'react-i18next';

export const quoteInfoFormSchema = (t: TFunction) =>
    yup.object({
        name: yup
            .string()
            .min(3, t('ERRORS.MIN_3'))
            .required(t('ERRORS.REQUIRED')),
        valid_from: yup
            .date()
            .typeError(t('ERRORS.REQUIRED'))
            .required(t('ERRORS.REQUIRED')),
        valid_until: yup
            .date()
            .typeError(t('ERRORS.REQUIRED'))
            .when('valid_from', (valid_from, schema) => {
                if (!valid_from) return schema;
                return schema.min(valid_from, t('ERRORS.VALID_UNTIL_ERROR'));
            })
            .required(t('ERRORS.REQUIRED')),
        comment_1: yup.string().nullable().notRequired(),
    });
